import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ openReturnPolicy,openPrivacyPolicy }) 
{  return (
    <footer className="border-t border-gray-200 py-12 px-6 sm:px-12">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-3 gap-12">
        <div>
          <h4 className="font-medium mb-4 text-sm">Contact</h4>
          <p className="text-gray-600 text-sm">zipnzip01@gmail.com</p>
        </div>

        <div>
          <h4 className="font-medium mb-4 text-sm">Shop</h4>
          <Link to="/shop" className="text-gray-600 text-sm hover:text-black">
            Product
          </Link>
        </div>

        <div>
          <h4 className="font-medium mb-4 text-sm">Policy</h4>
          <button
  onClick={openReturnPolicy}
  className="text-gray-600 text-sm hover:text-black block text-left"
>
  Returns
</button>         
   <button
  onClick={openPrivacyPolicy}
  className="text-gray-600 text-sm hover:text-black block text-left"
>
  Privacy
</button>          </div>
      </div>

      <div className="text-center text-gray-400 text-xs mt-8">
        © 2026 zipNzip. All rights reserved.
      </div>
    </footer>
  );
}
